import { useEffect, useState } from "react";
import { User } from "firebase/auth";

export const useClaims = (user: User | null | undefined): [Claims | undefined, boolean, Error | undefined] => {
  const [claims, setClaims] = useState<Claims | undefined>();
  const [claimsUid, setClaimsUid] = useState<string | undefined>();
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    let cancelled = false;

    if (user) {
      user
        .getIdTokenResult()
        .then((tokenResult) => {
          if (!cancelled) {
            setClaims(tokenResult.claims as Claims);
          }
        })
        .catch((e) => {
          if (!cancelled) {
            console.error("Error fetching claims:", e);
            setError(e as Error);
          }
        })
        .finally(() => {
          if (!cancelled) setClaimsUid(user.uid);
        });
    } else {
      setClaims(undefined);
      setClaimsUid(undefined);
    }

    return () => {
      cancelled = true;
    };
  }, [user]);

  // Derived synchronously: a signed-in user whose claims haven't been fetched yet means "loading".
  // Tracking this with a useState flag leaves a render where the user exists, claims are undefined
  // and loading is false — route guards then <Navigate> the freshly restored session away (e.g.
  // reloading a challenge deeplink bounced the guest to the challenges list via the landing page).
  const loading = !!user && claimsUid !== user.uid;

  return [claims, loading, error];
};
